import './App.css';
import Nav from "./components/Nav"
import React from "react"
import { Routes, Route} from "react-router-dom";
import MainWebsite from "./components/MainWebsite"
import Footer from "./components/Footer"
import Menu from "./components/Menu"
import Contact from "./components/Contact"
import About from "./components/About"
import Cart from "./components/Cart"
import 'aos/dist/aos.css';
import Aos from "aos"

function App() {
  React.useEffect(() => {
    Aos.init({
        duration: 1000
    })
}, [])

  const [dropdownState, changeDropdown] = React.useState(false);

  function changeDropdownState() {
    changeDropdown(!dropdownState)
  }

  function changeDropdownUp() {
    changeDropdown(false)
  }

  dropdownState ? document.body.style.overflow = "hidden" : document.body.style.overflow = "initial"
 
  return (
    <Routes>

      {/*Home Page*/}
      <Route path="/" element={
        <>
          <Nav 
            changeDropdownState={changeDropdownState}
            dropdownState={dropdownState}
            changeDropdownUp={changeDropdownUp}
          />
          <MainWebsite />
          <Footer />
        </>
      } />

      {/*Menu Page*/}
      <Route path="/menu" element={
        <>
          <Nav 
            changeDropdownState={changeDropdownState}
            dropdownState={dropdownState}
            changeDropdownUp={changeDropdownUp}
          />
          <Menu />
          <Footer />
        </>
      } />

      {/*Contact Page*/}
      <Route path="/contact" element={
        <>
          <Nav 
            changeDropdownState={changeDropdownState}
            dropdownState={dropdownState}
            changeDropdownUp={changeDropdownUp}
          />
          <Contact />
          <Footer />
        </>
      } />

      {/*About Page*/}
      <Route path="/about" element={
        <>
          <Nav 
            changeDropdownState={changeDropdownState}
            dropdownState={dropdownState}
            changeDropdownUp={changeDropdownUp}
          />
          <About />
          <Footer />
        </>
      } />

      {/*Cart Page*/}
      <Route path="/cart" element={
        <>
          <Nav 
            changeDropdownState={changeDropdownState}
            dropdownState={dropdownState}
            changeDropdownUp={changeDropdownUp}
          />
          <Cart />
        </>
      } />
    </Routes>
  );
}

export default App;
